// extracted by mini-css-extract-plugin
export default {"component":"I08gI"};